import './main.less';
import Table from './table';
import ReorderTable from './reorder-table';
import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors, actions } from './../additional-list';

import PageContainer from '../../shared/page-container/main';
import tabs from '../tabs';

class Main extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isReorderMode:  false };
		this.toggleReorder = this.toggleReorder.bind(this);
	}
	toggleReorder() {
		this.setState(state => ({ isReorderMode: !state.isReorderMode }));
	}
	render() {
		const functions = { saveReorder: this.saveReorder, toggleReorder: this.toggleReorder };
		return (
			<PageContainer name='List of location plans' tabs={tabs}>
				{
					this.state.isReorderMode
						? <TableReorderContainer {...this.props} {...functions}/>
						: <TableContainer {...this.props} {...functions} />
				}
			</PageContainer>
		);
	}
}

class TableContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { data: [], editingGeoCode: null };
		this.updateLocationsData = this.updateLocationsData.bind(this);
		this.setEditingCountryCode = this.setEditingCountryCode.bind(this);
	}
	updateLocationsData() {
		axios.get('v2/offers/locations-plan')
			.then(data => this.setState({ data: data.data }));
	}
	setEditingCountryCode(code) {
		this.setState(state => ({...state, editingGeoCode: code}));
	}
	componentDidMount() {
		this.updateLocationsData();
	}

	render() {
		return (
			<Table
				{...this.props}
				rows={this.state.data}
				editingGeoCode={this.state.editingGeoCode}
				updateLocationsData={this.updateLocationsData}
				setEditingCountryCode={this.setEditingCountryCode}
			/>
		);
	}

}

class TableReorderContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { data: [], editingGeoCode: null };
		this.updateLocationsData = this.updateLocationsData.bind(this);
		this.setEditingCountryCode = this.setEditingCountryCode.bind(this);
		this.saveReorder = this.saveReorder.bind(this);
		this.saveOrder = this.saveOrder.bind(this);
	}
	updateLocationsData() {
		axios.get('v2/offers/locations-plan')
			.then(data => this.setState({ data: data.data }));
	}
	setEditingCountryCode(code) {
		this.setState(state => ({...state, editingGeoCode: code}));
	}
	saveReorder(rows) {
		const countryCodes = rows.map(rr => rr.entityId);

		this.setState(state => ({
			...state,
			data: state.data
				.sort((val, nextVal) => countryCodes.indexOf(val.country_code) - countryCodes.indexOf(nextVal.country_code))
				.map((item, index) => ({ ...item, table_order: index }))
		}));
	}
	saveOrder() {
		return axios.post('v2/offers/locations-plan-order', this.state.data)
			.then(this.props.toggleReorder);
	}
	componentDidMount() {
		this.updateLocationsData();
	}

	render() {
		return (
			<ReorderTable
				{...this.props}
				rows={this.state.data}
				editingGeoCode={this.state.editingGeoCode}
				updateLocationsData={this.updateLocationsData}
				saveReorder={this.saveReorder}
				saveOrder={this.saveOrder}
				setEditingCountryCode={this.setEditingCountryCode}
			/>
		);
	}

}

export default connect(
	state => ({
		data: [],
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: false,
		progressBar: selectors.getProgressBar(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/locations-plan/main.js